import React from 'react'
import useBusinessInfo from '../../../hooks/useBusinessInfo'
import { Link } from 'react-router-dom';
import { CalendarMonth, ContentPaste, Notifications, Receipt } from '@mui/icons-material';
import Calendar from 'react-calendar';

function AppFooter() {

    

    return (
        <div className=''>
            <div style={{marginTop:100}}/>
            
            <div  className='navbar bg-primary border-bottom border-body rounded-top' style={{position:"fixed", bottom:0, width:"100%"}}>
                <div className="d-flex justify-content-around" style={{width:"100%",fontSize:10}}>
                    <Link to={"/token-details"} className='text-white text-center text-decoration-none'>
                        <div><Receipt/></div>
                        <div>Token</div>
                    </Link>
                    <Link to={"/followup-list"} className='text-white text-center text-decoration-none'>
                        <div><CalendarMonth/></div>
                        <div>Follow Up</div>
                    </Link>
                    <Link to={"/customer-profiles"} className='text-white text-center text-decoration-none'>
                        <div><ContentPaste/></div>
                        <div>Records</div>
                    </Link>
                    <Link to={"/notification-list"} className='text-white text-center text-decoration-none'>
                        <div><Notifications/></div>
                        <div>Notifications</div>
                    </Link>
                </div>
            </div>
            
            
        </div>
    )
}

export default AppFooter